import { render, staticRenderFns } from "./PortalStepperHeader.vue?vue&type=template&id=2b4db460&scoped=true&"
import script from "./PortalStepperHeader.vue?vue&type=script&lang=ts&"
export * from "./PortalStepperHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PortalStepperHeader.vue?vue&type=style&index=0&id=2b4db460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4db460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VFlex,VLayout,VStepperHeader,VStepperStep})
